import React from "react";
import g from "glamorous";
import { css } from "glamor";
import Layout from "../components/layout";
import Menu from "../components/Menu";
import Footer from "../components/Footer";
import { Link } from "gatsby";
import { Container, Row, Col } from "glamorous-grid";
import { Helmet } from "react-helmet";
import { FaHome } from "react-icons/fa";

export default function Techniques({
  data, // this prop will be injected by the GraphQL query below.
}) {
  // data.markdownRemark holds our post data

  const mediaQueries = {
    phone: "@media only screen and (max-width: 991px)",
  };

  const WhiteRow = g.section({
    backgroundColor: `white`,
    padding: `2em 0`,
    borderBottom: `1px solid #e9eaeb`,
  });

  const GreyRow = g.section({
    backgroundColor: `#f6f7f8`,
    padding: `2em 0`,
    borderBottom: `1px solid #e9eaeb`,
  });

  const H1 = g.h1({
    fontSize: `2.9em`,
    letterSpacing: `.08em`,
    fontWeight: `600`,
    marginTop: `2em`,
    color: `#3c4d68`,
    margin: `40px 0 .3em`,
    [mediaQueries.phone]: {
      fontSize: `2.4em`,
    },
  });

  const Subtitle = g.div({
    color: `#3c4d68`,
    fontWeight: `400`,
    fontSize: `1.05em`,
    letterSpacing: `.03em`,
    marginBottom: `.5em`,
  });

  const cssButton = css({
    color: `white`,
    backgroundColor: `#3c4d68`,
    border: `1px solid #3c4d68`,
    padding: `.5em 1.5em`,
    display: `block`,
    margin: `58px 0 10px`,
    borderRadius: `5px`,
    textAlign: `center`,
    fontWeight: `500`,
    width: `215px`,
    float: `right`,
    textDecoration: `none`,
    letterSpacing: `.03em`,
    transition: `all 0.3s ease-in-out 0s`,
    ":hover": {
      backgroundColor: `white`,
      color: `#3c4d68`,
      transition: `all 0.3s ease-in-out 0s`,
    },
    [mediaQueries.phone]: {
      margin: `28px 0 10px`,
    },
  });

  const H2 = g.h2({
    fontVariant: `small-caps`,
    fontSize: `1.8em`,
    letterSpacing: `.1em`,
    fontWeight: `500`,
    margin: `0 0 .6em`,
  });

  const cssLink = css({
    color: `#2c2e31`,
    textDecoration: `none`,
    fontSize: `1em`,
    borderBottom: `none`,
    transition: `all .3s`,
    padding: `0 0 4px 0`,
    lineHeight: `30px`,
    margin: `0`,
    position: `relative`,
    "::before": {
      content: " ",
      position: `absolute`,
      width: `100%`,
      height: `1px`,
      bottom: `0`,
      left: `0`,
      backgroundColor: `#2c2e31`,
      visibility: `invisible`,
      transform: `scaleX(0)`,
      transition: `all 0.3s ease-in-out 0s`,
    },
    ":hover": {
      transition: `all .3s`,
      border: `none`,
      background: `none`,
      padding: `0 0 3px 0`,
      margin: `0`,
      "::before": {
        visibility: `visible`,
        transform: `scaleX(1)`,
        transition: `all 0.3s ease-in-out 0s`,
      },
    },
  });

  const cssLinkTitle = css({
    color: `#3c4d68`,
    textDecoration: `none`,
    fontSize: `1em`,
    borderBottom: `none`,
    transition: `all .3s`,
    padding: `0 0 4px 0`,
    lineHeight: `30px`,
    margin: `0`,
    position: `relative`,
    "::before": {
      content: " ",
      position: `absolute`,
      width: `100%`,
      height: `3px`,
      bottom: `0`,
      left: `0`,
      backgroundColor: `#3c4d68`,
      visibility: `invisible`,
      transform: `scaleX(0)`,
      transition: `all 0.3s ease-in-out 0s`,
    },
    ":hover": {
      transition: `all .3s`,
      border: `none`,
      background: `none`,
      padding: `0 0 4px 0`,
      margin: `0`,
      "::before": {
        visibility: `visible`,
        transform: `scaleX(1)`,
        transition: `all 0.3s ease-in-out 0s`,
      },
    },
  });

  const Breadcrumb = g.ul({
    fontSize: `13px`,
    lineHeight: `20px`,
    marginLeft: `0 !important`,
    marginTop: `0`,
    marginBottom: `10px !important`,
    fontWeight: `500`,
    letterSpacing: `.015em`,
  });

  const BreadcrumbItem = g.li({
    display: `inline`,
    "&:first-of-type": {
      "&::before": {
        content: `none`,
      },
    },
    "&::before": {
      content: `/`,
      padding: `0 .5em`,
    },
  });

  const cssBreadcrumbLink = css({
    color: `#3c4d68`,
    borderBottom: `none`,
  });

  return (
    <Layout>
      <g.Div id="page-wrap" margin={`0 auto`} backgroundColor={`#fcfcfc`}>
        <Helmet>
          <title>
            Techniques de médecine et de chirurgie esthetiques | Dr Cédric Kron
          </title>
          <meta
            name="description"
            content="Techniques de médecine et de chirurgie esthétique pratiquées par le Dr Kron : lifting, injections de botox,acide hyaluronique, laser, peeling, chirurgie réparatrice."
          />
          <html lang="fr" />
          <link
            rel="alternate"
            hreflang="en"
            href="https://www.dr-kron.com/en/procedures/"
          />
          <script type="application/ld+json">{` {
          "@context": "http://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [{
          "@type": "ListItem",
          "position": 1,
          "name": "Techniques",
          "item": "https://www.dr-kron.com/techniques/"
          }]
              }
    `}</script>
        </Helmet>
        <Menu current="interventions" pathEn="/en/procedures/" />
        <main>
          <WhiteRow css={{ paddingBottom: `8px !important` }}>
            <Container>
              <Row>
                <Col>
                  <H1>Interventions</H1>
                  <Subtitle>Par techniques</Subtitle>
                  <Breadcrumb
                    css={{
                      marginTop: `3em !important`,
                      "@media only screen and (max-width: 600px)": {
                        display: `none`,
                      },
                    }}
                  >
                    <BreadcrumbItem>
                      <Link
                        to="/"
                        {...cssBreadcrumbLink}
                        title="Page d'accueil"
                      >
                        <FaHome
                          css={{
                            fontSize: `1.2em`,
                            paddingBottom: `.2em`,
                            transform: `translateY(5px)`,
                          }}
                        />
                      </Link>
                    </BreadcrumbItem>
                    <BreadcrumbItem>Techniques</BreadcrumbItem>
                  </Breadcrumb>
                </Col>
                <Col>
                  <Link {...cssButton} to="/interventions/">
                    Voir les régions du corps
                  </Link>
                </Col>
              </Row>
            </Container>
          </WhiteRow>
          <GreyRow>
            <Container>
              <Row>
                <Col>
                  <H2>
                    <Link {...cssLinkTitle} to="/acide-hyaluronique/">
                      Acide Hyaluronique / Comblement
                    </Link>
                  </H2>
                </Col>
              </Row>
              <Row>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/visage/comblement-rides-acide-hyaluronique/"
                  >
                    Comblement des rides
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/cernes/comblement-cernes-creux-acide-hyaluronique/"
                  >
                    Comblement des cernes creux
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/ellanse/">
                    ELLANSÉ®
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/hydrafacial/">
                    HydraFacial
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/mesolift-nctf/">
                    Mésolift NCTF
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/sexe/augmentation-point-g/">
                    Augmentation du point G
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/nez/rhinoplastie-medicale/">
                    Rhinoplastie médicale
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/comblement-rides-front/">
                    Rides du front
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/actualites/sisthaema/">
                    Sisthaema
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/skinbooster/">
                    Skinbooster
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/traitement-esthetique-levres/">
                    Traitements esthétiques des lèvres
                  </Link>
                </Col>
              </Row>
            </Container>
          </GreyRow>
          <WhiteRow>
            <Container>
              <H2>
                <Link {...cssLinkTitle} to="/botox/">
                  Botox
                </Link>
              </H2>
              <Row>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/bruxisme/">
                    Bruxisme
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/traitement-migraine-botox/">
                    Migraine
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/regard/patte-d-oie-botox/">
                    Patte d'oie
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/rajeunissement-cou-botox/">
                    Rajeunissement du cou
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/reduction-machoire-botox/">
                    Réduction de la mâchoire
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/regard/lifting-du-front/">
                    Rides de la patte d’oie
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/supprimer-rides-front/">
                    Rides du front
                  </Link>
                </Col>
              </Row>
            </Container>
          </WhiteRow>

          <GreyRow>
            <Container>
              <Row>
                <Col>
                  <H2>
                    <Link {...cssLinkTitle} to="/lifting/">
                      Lifting
                    </Link>
                  </H2>
                </Col>
              </Row>
              <Row>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/regard/blepharoplastie-chirurgie-paupieres/"
                  >
                    Blépharoplastie
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/silhouette/bodylift/">
                    Bodylift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/bras/lifting-plastie/">
                    Lifting des bras
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/jambes/lifting-des-cuisses/">
                    Lifting des cuisses
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/seins/rajeunissement-mammaire-correction-ptose/"
                  >
                    Lifting des seins
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                <Link {...cssLink} to="/visage/lifting-du-cou-platysmaplastie/">
                  Lifting du cou - Platysmaplastie
                </Link>
              </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/regard/lifting-du-front/">
                    Lifting du front
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/lifting-visage-paris/">
                    Lifting du visage LVPA
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/lifting-cervico-facial/">
                    Lifting cervico-facial
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/cernes/lifting-malaire-cernes-creux/">
                    Lifting malaire
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/chirurgie-esthetique-sous-anesthesie-locale/#mini-lift"
                  >
                    Mini-lift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/silhouette/mommy-makeover/">
                    Mommy makeover
                  </Link>
                </Col>
              </Row>
            </Container>
          </GreyRow>
          <WhiteRow>
            <Container>
              <H2>
                <Link {...cssLinkTitle} to="/chirurgie-plastique/">
                  Chirurgie Plastique
                </Link>
              </H2>
              <Row>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/seins/protheses-mammaires/">
                    Augmentation mammaire
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/regard/blepharoplastie-asiatique/">
                    Blépharoplastie asiatique
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/cernes/blepharoplastie-inferieure/">
                    Bl&eacute;pharoplastie inférieure
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/silhouette/bodylift/">
                    Bodylift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/regard/blepharoplastie-chirurgie-paupieres/"
                  >
                    Chirurgie des paupières
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/chirurgie-esthetique-sous-anesthesie-locale/"
                  >
                    Chirurgie sous anesthésie locale
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/genioplastie/">
                    Génioplastie (menton)
                  </Link>
                </Col>

                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/seins/lipostructure/">
                    Lipostructure des seins
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/silhouette/mommy-makeover/">
                    Mommy makeover
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/silhouette/plastie-abdominale/">
                    Plastie abdominale
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/silhouette/remodelage-fesses/">
                    Plastie des fesses
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/seins/rajeunissement-mammaire-correction-ptose/"
                  >
                    Rajeunissement mammaire
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/seins/reduction-mammaire/">
                    Réduction mammaire
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/nez/rhinoplastie/">
                    Rhinoplastie
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/nez/rhinoplastie-ethnique/">
                    Rhinoplastie ethnique
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/nez/rhinoplastie-secondaire/">
                    Rhinoplastie secondaire
                  </Link>
                </Col>
              </Row>
            </Container>
          </WhiteRow>

          <GreyRow>
            <Container>
              <Row>
                <Col>
                  <H2>
                    <Link {...cssLinkTitle} to="/chirurgie-reparatrice/">
                      Chirurgie Réparatrice
                    </Link>
                  </H2>
                </Col>
              </Row>
              <Row>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/silhouette/bodylift/">
                    Bodylift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/bras/syndrome-canal-carpien/">
                    Syndrome du canal carpien
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/peau/correction-cicatrices/">
                    Chirurgie des cicatrices
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/nez/septoplastie/">
                    Déviation de la cloison nasale
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/oreilles/earfold-correction-oreilles-decollees/"
                  >
                    EarFold
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/lobes-oreilles/">
                    Lobes d’oreilles déchirés
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/traitement-migraine-botox/">
                    Migraine
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/bras/decompression-nerf-cubital/">
                    Décompression du nerf cubital
                  </Link>
                </Col>

                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/sexe/nymphoplastie-reduction-levres/">
                    Nymphoplastie
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/oreilles/oreilles-decollees/">
                    Otoplastie
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/silhouette/poitrine-homme-gynecomastie/"
                  >
                    Poitrine chez l’homme
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/seins/rajeunissement-mammaire-correction-ptose/"
                  >
                    Ptôse mammaire
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/seins/reconstruction-mammaire/">
                    Reconstruction mammaire
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/nez/septoplastie/">
                    Septoplastie
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/peau/chirurgie-tumeurs-cutanees/">
                    Tumeurs cutanées
                  </Link>
                </Col>
              </Row>
            </Container>
          </GreyRow>

          <WhiteRow>
            <Container>
              <H2>
                <Link {...cssLinkTitle} to="/peau/">
                  Réjuvénation de la peau
                </Link>
              </H2>
              <Row>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/carboxytherapie/">
                    Carboxythérapie du visage
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/consultation-diagnostic/">
                    Consultation Diagnostic Visage
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/visage/couperose-rosacee-erythrose-laser/"
                  >
                    Couperose, rosacée et érythrose
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/visage/fils-tenseurs-silhouette-soft/"
                  >
                    Fils tenseurs
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/hydrafacial/">
                    HydraFacial
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/peau/keybody-skin/">
                    Keybody-Skin
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/peau/keybody-skin-plus/">
                    Keybody-Skin Plus
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/peau/lasemd-ultra/">
                    LaseMD Ultra
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/peau/laser-icon-correction-imperfections/"
                  >
                    Laser Icon
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/mesolift-nctf/">
                    Mésolift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/silhouette/onda-coolwaves/">
                    ONDA Coolwaves
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/peau/peeling-bioretivalisant-prx-t33/"
                  >
                    Peeling biorevitalisant
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/peeling-rides-patte-d-oie/">
                    Peeling de la patte d’oie
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/peeling-combine/">
                    Peeling combiné
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/cernes/peeling-depigmentant-cernes/">
                    Peeling dépigmentant des cernes
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/peau/PRP-plasma-riche-plaquettes/">
                    Plasma Riche Plaquette (PRP)
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/regard/plexr/">
                    Plexr®
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/actualites/sisthaema/">
                    Sisthaema
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/skinbooster/">
                    Skinbooster
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/silhouette/keybody-cellulite/">
                    Traitement de la cellulite
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/universkin/">
                    Universkin&nbsp;: Cosmétique médicale
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/peau/supprimer-vergetures/">
                    Vergetures
                  </Link>
                </Col>
              </Row>
            </Container>
          </WhiteRow>

          <GreyRow>
            <Container>
              <Row>
                <Col>
                  <H2>
                    <Link {...cssLinkTitle} to="/protheses/">
                      Prothèses / Implants{" "}
                    </Link>
                    /{" "}
                    <Link {...cssLinkTitle} to="/lipostructure/">
                      Lipostructure
                    </Link>
                  </H2>
                </Col>
              </Row>
              <Row>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/seins/protheses-mammaires/">
                    Augmentation mammaire
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/oreilles/earfold-correction-oreilles-decollees/"
                  >
                    Earfold - oreilles décollées
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/cernes/lipostructure-des-cernes/">
                    Lipostructure des cernes
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/traitement-esthetique-levres/">
                    Lipostructure des lèvres
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/jambes/lipostructure-mollet/">
                    Lipostructure des mollets
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/seins/lipostructure/">
                    Lipostructure des seins
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/seins/augmentation-macrolane/">
                    Macrolane
                  </Link>
                </Col>

                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/silhouette/remodelage-fesses/">
                    Plastie des fesses
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/jambes/protheses-mollets/">
                    Prothèses des mollets
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/silhouette/implants-fessiers/">
                    Prothèses de fesses
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/sexe/augmentation-point-g/">
                    Point G
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/seins/retirer-implants-mammaires/">
                    Retirer ses implants mammaires
                  </Link>
                </Col>
              </Row>
            </Container>
          </GreyRow>

          <WhiteRow css={{ paddingBottom: `6em` }}>
            <Container>
              <H2>
                <Link {...cssLinkTitle} to="/suppression-des-graisses/">
                  Suppression des Graisses
                </Link>
              </H2>
              <Row>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/silhouette/bodylift/">
                    Bodylift
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/silhouette/consultation-diagnostic/">
                    Consultation Diagnostic Silhouette
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/silhouette/cryolipolyse-coolsculpting/"
                  >
                    Coolsculpting
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/supprimer-double-menton/">
                    Double menton
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/silhouette/emsculpt/">
                    EMSculpt
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/silhouette/keybody-cellulite/">
                    Keybody-Cellulite
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/silhouette/keybody-lipo/">
                    Keybody-Lipo
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/silhouette/lipoaspiration/">
                    Lipoaspiration
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/bras/lipoaspiration/">
                    Lipoaspiration des bras
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/supprimer-double-menton/">
                    Lipoaspiration du menton
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/jambes/lipoaspiration-mollets/">
                    Lipoaspiration des mollets
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/lipoaspiration-visage-cou/">
                    Lipoaspiration du visage et du cou
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/chirurgie-esthetique-sous-anesthesie-locale/#liposuccion-douce"
                  >
                    Liposuccion douce
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link
                    {...cssLink}
                    to="/silhouette/liposuccion-culotte-de-cheval/"
                  >
                    Liposuccion de la culotte de cheval
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/silhouette/mommy-makeover/">
                    Mommy makeover
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/silhouette/onda-coolwaves/">
                    ONDA Coolwaves
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/silhouette/phototherapie-dynamique/">
                    Photothérapie dynamique
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/visage/supprimer-bajoues/">
                    Supprimer les bajoues
                  </Link>
                </Col>
                <Col span={{ xs: 12 / 12, sm: 6 / 12, md: 4 / 12, lg: 3 / 12 }}>
                  <Link {...cssLink} to="/xbody-sculpter-raffermir-son-corps/">
                    XBody
                  </Link>
                </Col>
              </Row>
            </Container>
          </WhiteRow>
        </main>
        <Footer />
      </g.Div>
    </Layout>
  );
}
